<template>
  <div class="MobileVerificationCodeLogin">
    <div class="login-inner">
      <div class="login-content">
        <div class="login-title">手机验证码登录</div>
        <div class="login-title-line"></div>
        <!-- <span class="iconfont icon-shouji"></span>
        <span class="iconfont icon-anquan"></span> -->
        <van-form @submit="onSubmit" ref="loginForm" class="login-form">
          <van-field type="digit" v-model="user.phone" name="手机号" placeholder="请输入11位手机号" maxlength="11" class="iconfont icon-shouji" :rules="[
              { required: true, message: '必填' },
              { pattern: /^\d{11}$/, message: '手机号有误' },
            ]" />
          <van-field v-model="user.identifying_code" type="number" name="验证码" placeholder="请输入验证码" maxlength="6" class="iconfont icon-anquan" :rules="[
              { required: true, message: '必填' },
              { pattern: /^[0-9]{6}$/, message: '验证码有误' },
            ]">
            <template #button>
              <!-- 倒计时 -->
              <van-count-down :time="time" format="ss s" v-if="isCountDownShow" @finish="isCountDownShow = false" />
              <!-- 验证码 -->
              <span v-else @click.prevent="onSendSms" native-type="button" class="send-identifying_code-btn" round size="mini" type="default">
                获取验证码
              </span>
            </template>
          </van-field>
          <div class="login-nc">
            <a href="javascript:;" class="send-identifying_code-btn" @click="toRegister">立即注册</a>
          </div>
          <div class="login-submit">
            <van-button class="login-submit-btn" round block type="info" native-type="submit"><span>提</span><span>交</span></van-button>
          </div>
        </van-form>

        <div class="notice">
          <a href="javascript:;" @click="toAccountLogin">账号密码登录></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AreaCode from '@/utils/areaCode'

import { encrypt } from '@/utils/security'

import { mapState, mapMutations } from 'vuex'

export default {
  name: 'MobileVerificationCodeLogin',
  props: {},
  data () {
    return {
      isCountDownShow: false,
      time: 60 * 1000,
      user: {
        // 用户名
        phone: '',
        // 验证码
        identifying_code: ''
      },
      isShowpassword: false,
      inputType: 'password',
      appkey: 'FFFF0N00000000009556',
      NC: null,
      scene: 'nc_login',
      redirectUrl: '/',
      areaCodeArr: AreaCode,
      areacode: AreaCode[0].code
    }
  },
  created () { },
  // mounted () {
  // },
  methods: {
    ...mapMutations(['setShowLoading', 'setUserInfo', 'setToastData']),

    onSubmit () {
      const { phone, identifying_code: code } = this.user
      // 登陆接口
      this.$Api
        .phoneLogin({
          phone: encrypt(phone),
          code: encrypt(code),
          areaCode: this.areacode,
          invitedCode: ''
        })
        .then((res) => {
          // 先跳转到首页
          localStorage.setItem('userInfo', JSON.stringify(''))
          localStorage.setItem('userInfo', JSON.stringify(res))
          // 再次请求用户信息，看是否登录
          setTimeout(() => {
            this.$Api.userGet({}, { noToast: true }).then(data => {
              if (!data) localStorage.setItem('userInfo', '')
              // 是否为注册页面登录
              if (this.$route.path == '/reportDetails') {
                this.setActiveName(true)
                // this.$router.go(0)
              } else {
                // 先跳转到首页
                this.$router.push('/')
              }
            }).catch(() => {
              localStorage.setItem('userInfo', '')
            })
          }, 500)
        })
      this.$emit('LoginSuccess', true)
    },
    // 验证码点击注册
    async onSendSms () {
      try {
        await this.$refs.loginForm.validate('手机号')
      } catch (err) {
        return console.log('验证失败', err)
      }
      // 验证通过显示倒计时
      this.isCountDownShow = true
      // 请求发送验证码

      // 请求接口
      await this.$Api.sendCode({
        phone: encrypt(this.user.phone)
      })
      this.$toast('发送成功')
    },
    toAccountLogin () {
      this.$emit('toAccountLogin', 'AccountLogin')
    },
    toRegister () {
      this.$router.push('/register')
    }
  },
  computed: {
    ...mapState(['lang'])
  },
  watch: {},
  components: {}
}
</script>

<style lang="scss" scoped>
.login-inner {
  box-shadow: 0 1.06vw 4.1vw 0 rgb(0 0 0 / 15%);
  border-radius: 8px;
  background: #fafafa;
  padding: 8.333vw 11.852vw;
}
.login-inner {
}
.login-content {
  position: relative;
  background-color: #fff;
  // box-shadow: 0 0.833vw 6.111vw 0 rgba(44, 44, 44, 0.11);
  padding: 8.333vw 4.63vw 5.556vw;
}
.login-title {
  width: 100%;
  text-align: center;
  padding-top: 6.333vw;
  padding-bottom: 8.333vw;
}
.login-title-line {
  position: absolute;
  top: 25vw;
  left: 35vw;
  width: 7vw;
  border-bottom: 1vw solid #0852c8;
}
.login-item {
  margin-bottom: 6.019vw;
  position: relative;
  .msg-tips {
    color: red;
    font-size: 2.778vw;
    position: absolute;
    left: 0;
    width: 100%;
    bottom: -4.167vw;
  }
  .borders {
    border-bottom: 1px solid #000;
  }
  input {
    width: 60%;
    font-size: 2.778vw;
    appearance: none;
    outline: none;
    box-sizing: border-box;
    border: none;
    border-radius: 0;
    margin-bottom: 1.778vw;
    padding: 1vw 0;
  }
  a {
    font-size: 2.778vw;
    text-decoration: none;
    color: #013995;
  }
}
.notice {
  color: #757575;
  font-size: 2.963vw;
  text-align: center;
  line-height: 1.4;
  margin-top: 8.148vw;
  a {
    text-decoration: none;
    color: #013995;
  }
}
.login-btn {
  button {
    font-size: 3.889vw;
    color: #fff;
    font-weight: bold;
    appearance: none;
    outline: none;
    border: none;
    height: 8.796vw;
    width: 100%;
    border-radius: 4.444vw;
    background: linear-gradient(139deg, #2e76f3, #3f55c2);
    &.disabled {
      background: linear-gradient(139deg, #a7a7a7, #c5c5c5);
    }
  }
}
.bottomLine {
  border: 0.0125rem solid black;
}
.send-identifying_code-btn {
  color: #2e76f3;
}
.login-content {
  position: relative;
  background-color: #fff;
  padding: 8.333vw 4.63vw 5.556vw;
  text-align: center;
}
.login-title {
  width: 100%;
  text-align: center;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: #333333;
  font-size: 5.3333vw;
  height: 6.9vw;
}
.login-inner {
  background-color: #ffffff;
  border-radius: 0.926vw;
  padding: 0 7.13vw;
  .login-inner-title {
    font-size: 4.074vw;
    color: #333330;
    line-height: 1.4;
    padding: 4.63vw 0 1.852vw;
    text-align: center;
    border-bottom: 0.278vw solid #006df1;
    margin-bottom: 3.241vw;
  }
  .login-nav {
    background-color: #d3e6ff;
    height: 8.704vw;
    border-radius: 0.278vw;
    display: flex;
    span {
      font-size: 3.426vw;
      font-weight: bold;
      color: #006df1;
      flex: 1;
      height: 100%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      &.active {
        color: #fff;
        background-color: #006df1;
      }
    }
  }
  .empty-wrapper {
    height: 73.889vw;
    .empty-inner {
      span {
        margin-top: 13.889vw;
        font-size: 0;
        width: 52.963vw;
        height: 10.741vw;
        line-height: 10.741vw;
        background-color: #f5faff;
        &::before {
          content: "敬请期待";
          font-size: 4.074vw;
          color: #80b9ff;
          font-weight: bold;
        }
      }
    }
  }
}
.login-form {
  margin: 13.333vw 0 8vw 0;
  .van-field {
    margin-bottom: 10.6vw;
    overflow: visible;
    position: relative;
    ::v-deep .van-cell__value {
      position: initial;
    }
    ::v-deep .van-field__error-message {
      position: absolute;
      left: 16px;
      bottom: -5vw;
    }
    ::v-deep .van-field__button {
      height: 24px;
    }
  }
}
.login-title-line {
  display: inline-block;
  width: 7vw;
  border-bottom: 1vw solid #0852c8;
}
.login-submit {
  height: 10.6667vw;
  display: flex;
  justify-content: center;
  .login-submit-btn {
    height: 10.6667vw;
    font-weight: bold;
    color: #ffffff;
    font-size: 4.26vw;
    line-height: 10.6667vw;
    background: #002fa7;
    span {
      margin: 0 6px;
    }
  }
}
.login-nc {
  display: flex;
  justify-content: flex-end;
  font-size: 4.2vw;
  padding: 0 16px;
  margin-bottom: 5.2vw;
  a {
    color: #002fa7;
    font-size: 4.26vw;
  }
}
</style>
